import { render, staticRenderFns } from "./JoysticRobo.vue?vue&type=template&id=291da56b&"
import script from "./JoysticRobo.vue?vue&type=script&lang=js&"
export * from "./JoysticRobo.vue?vue&type=script&lang=js&"
import style0 from "./JoysticRobo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports